/**
 * 泉港H5 1.0的api请求
 */
import request from "@/libs/request";
import {
    fileToBase64
} from "@/libs/tools";
/** 登录 */
/** 首页 */

/** 停车记录 */
// 停车记录列表
export const listMyParkingRecord = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/listMyParkingRecord",
        method: "post",
        data: data,
    });
};

// 停车记录详情
export const queryMyParkingRecordDetail = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/queryMyParkingRecordDetail",
        method: "post",
        data: data,
    });
};

/** 个人中心 */
// 获取余额 月卡 优惠券
export const queryBindPlateNumAndCouponNum = (data = {}) => {
    return request({
        url: "/qgvip/myHomeController/queryBindPlateNumAndCouponNum",
        method: "post",
        data: data,
    });
};
// 钱包充值前查询是否欠费
export const whetherPayment = (data = {}) => {
    return request({
        url: "/qgvip/arrearConfigController/queryIsAppearBeforeCharge",
        method: "post",
        data: data,
    });
};
// 获取个人信息
export const getPersonalInfo = (data = {}) => {
    return request({
        url: "/qgvip/personalController/getPersonalInfo",
        method: "post",
        data: data,
    });
};
// 更新个人信息
export const updatePersonalInfo = (data = {}) => {
    return request({
        url: "/qgvip/personalController/updatePersonalInfo",
        method: "post",
        data: data,
    });
};
// 实名认证状态
export const queryRealNameStatus = (data = {}) => {
    return request({
        url: "/qgvip/realNameController/queryRealNameStatus",
        method: "post",
        data: data,
    });
};

// 提交认证材料
export const submitRealNameCert = (data = {}) => {
    return request({
        url: "/qgvip/realNameController/submitRealNameCert",
        method: "post",
        data: data,
    });
};

/** 车辆模块 */
// 获取用户绑定的车牌
export const listMyPlateNum = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/listMyPlateNum",
        method: "post",
        data: data,
    });
};

// 新增绑定车牌
export const addPlateNum = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/addPlateNum",
        method: "post",
        data: data,
    });
};

// 删除绑定的车牌
export const deletePlateNum = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/deletePlateNum",
        method: "post",
        data: data,
    });
};
// 上传车牌认证
export const certPlateNum = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/certPlateNum",
        method: "post",
        data: data,
    });
};
// 更新车牌状态
export const setUp = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/unifiedPlateNumSetUp",
        method: "post",
        data: data,
    });
};
// 更新无感支付状态

export const updateUnionpayNoFeelStatus = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/updateUnionpayNoFeelStatus",
        method: "post",
        data: data,
    });
};

// 获取用户钱包无感开关状态
export const getWalletStatus = (data = {}) => {
    return request({
        url: "/qgvip/myHomeController/walletStatus",
        method: "post",
        data: data,
    });
};
// 更新钱包无感支付状态

export const updateUserWalletNofeelPay = (data = {}) => {
    return request({
        url: "/qgvip/myPlateNumController/updateUserWalletNofeelPay",
        method: "post",
        data: data,
    });
};

/** 停车模块 */
// 获取附近车场
export const getParkDistribute = (data = {}) => {
    return request({
        url: "/qgvip/parkDistributeController/getParkDistribute",
        method: "post",
        data: data,
    });
};
// 获取推荐车场
export const getSearchRecommendList = (data = {}) => {
    return request({
        url: "/qgvip/parkDistributeController/getSearchRecommendList",
        method: "post",
        data: data,
    });
};
// 获取推荐地点
export const listHotPlaces = (data = {}) => {
    return request({
        url: "/qgvip/parkDistributeController/listHotPlaces",
        method: "post",
        data: data,
    });
};

/** 开票模块 */
/** 月卡模块 */
/** 投诉建议模块 */
// 发起投诉建议
export const complaintAdvise = (data = {}) => {
    return request({
        url: "/qgvip/feedbackOpinion/complaintAdvise",
        method: "post",
        data: data,
    });
};
// 投诉建议列表
export const queryComplaintAdviseList = (data = {}) => {
    return request({
        url: "/qgvip/feedbackOpinion/queryComplaintAdviseList",
        method: "post",
        data: data,
    });
};
// 订单申诉
export const orderAppeal = (data = {}) => {
    return request({
        url: "/qgvip/feedbackOpinion/orderAppeal",
        method: "post",
        data: data,
    });
};

// 订单申诉列表
export const queryOrderAppealList = (data = {}) => {
    return request({
        url: "/qgvip/feedbackOpinion/queryOrderAppealList",
        method: "post",
        data: data,
    });
};

// 反馈意见消息详情
export const msgDetail = (data = {}) => {
    return request({
        url: "/qgvip/feedbackOpinion/msgDetail",
        method: "post",
        data: data,
    });
};

/** 微信鉴权 */
export const getScanSign = (data = {}) => {
    return request({
        url: "/qginsideparking/wxAuthController/getScanSign",
        method: "post",
        data: data,
    });
};

/** 上传文件 */
export const uploadImage = (file) => {
    return fileToBase64(file).then((res) => {
        let data = {
            base64Str: res.split(",")[1],
        };
        return request({
            url: "/qgvip/commonOSSController/uploadBase64Img",
            method: "post",
            data: data,
        });
    });
};

/** 缴费模块 */
// 通过车牌查询费用
export const queryParkingRecordByCarNo = (data = {}) => {
    return request({
        url: "/qgvip/parkingFeeSearchController/queryParkingRecordByCarNo",
        method: "post",
        data: data,
    });
};
// 获取用户车牌的欠缴订单
export const listPlateNumBill = (data = {}) => {
    return request({
        url: "/qginsideparking/insideParkingPayController/listPlateNumBill",
        method: "post",
        data: data,
    });
};

// 获取路外停车场是否开启强制缴费
export const getSysConfig = (data = {}) => {
    return request({
        url: "/qgvip/loginController/getSysConfig",
        method: "post",
        data: data,
    });
};
// 最优优惠券
export const queryBestSuitCoupon = (data = {}) => {
    return request({
        url: "/qgvip/commonCouponController/queryBestSuitCoupon",
        method: "post",
        data: data,
    });
};

// 路内 聚合支付
export const commonInsideOrderSubmit = (data = {}) => {
    return request({
        url: "/qginsideparking/insideParkingPayController/commonInsideOrderSubmit",
        method: "post",
        data: data,
    });
};

// 发起路内外聚合停车缴费APP支付或H5支付或余额充值
export const submitParkingOrderFromApp = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/submitParkingOrderFromApp",
        method: "post",
        data: data,
    });
};

// 获取活动状态 体验金type=3 充值优惠type=1 充值开关type=99

export const queryCashConfig = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/queryCashConfig",
        method: "post",
        data: data,
    });
};

/** 车辆账单 */
export const listMyBill = (data = {}) => {
    return request({
        url: "/qgvip/myNewBillController/listMyBill",
        method: "post",
        data: data,
    });
};

/** 优惠券模块 */
// 优惠券列表
export const listMyCoupon = (data = {}) => {
    return request({
        url: "/qgvip/myCouponController/listMyCoupon",
        method: "post",
        data: data,
    });
};
// 获取用户可用的优惠券列表
export const listCanUseCoupon = (data = {}) => {
    return request({
        url: "/qgvip/myCouponController/listCanUseCoupon",
        method: "post",
        data: data,
    });
};

/** 公告列表  */
// 公告列表
export const listBulletin = (data = {}) => {
    return request({
        url: "/qgzlptother/bulletinManageController/listBulletin",
        method: "post",
        data: data,
    });
};

// 新增公告
export const addBulletin = (data = {}) => {
    return request({
        url: "/qgzlptother/bulletinManageController/addBulletin",
        method: "post",
        data: data,
    });
};

// 编辑公告
export const editBulletin = (data = {}) => {
    return request({
        url: "/qgzlptother/bulletinManageController/editBulletin",
        method: "post",
        data: data,
    });
};

// 删除公告
export const delBulletin = (data = {}) => {
    return request({
        url: "/qgzlptother/bulletinManageController/delBulletin",
        method: "post",
        data: data,
    });
};
// 查询系统里是否有该泊位
export const queryParkInfoByStallCode = (data = {}) => {
    return request({
        url: "/qginsideparking/insideParkingPayController/queryParkInfoByStallCode",
        method: "post",
        data: data,
    });
};
// 首页轮播banner
export const queryHomeTopBanner = (data = {}) => {
    return request({
        url: "/qgvip/advertisingManageController/queryAdvertising",
        method: "post",
        data: data,
    });
};

// 通过code拿openId
export const getOpenIdByCode = (data = {}) => {
    return request({
        url: "/qginsideparking/wxAuthController/getOpenIdByCode",
        method: "post",
        data: data,
    });
};

// 登录
export const login = (data = {}) => {
    return request({
        url: "/qgvip/loginController/login",
        method: "post",
        data: data,
    });
};
// 获取验证码
export const getSmsCode = (data = {}) => {
    return request({
        url: "/qgvip/loginController/getSmsCode",
        method: "post",
        data: data,
    });
};

// 获取用户是否有代付充值权限
export const getMerchantCanUse = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getMerchantCanUse",
        method: "post",
        data: data,
    });
};

// 获取代付充值开关
export const getMerchantChargeConfig = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getMerchantChargeConfig",
        method: "post",
        data: data,
    });
};

// 获取商户代付余额
export const getMerchantMoney = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getMerchantMoney",
        method: "post",
        data: data,
    });
};

// 获取代付充值配置
export const getMyMerchantRule = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getMyMerchantRule",
        method: "post",
        data: data,
    });
};

// 获取商户代付明细列表
export const listMyPaymentOnBehalfBill = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/listMyPaymentOnBehalfBill",
        method: "post",
        data: data,
    });
};

// 根据代付码获取动态码
export const getDynamicsCode = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getDynamicsCode",
        method: "post",
        data: data,
    });
};

// 获取代付码详情
export const getPaymentCodeDetail = (data = {}) => {
    return request({
        url: "/qgvip/myPaymentOnBehalfController/getPaymentCodeDetail",
        method: "post",
        data: data,
    });
};

// 根据车牌号获取代付列表
export const queryParkingRecordPaymentOnBehalf = (data = {}) => {
    return request({
        url: "/qgvip/parkingFeeSearchController/queryParkingRecordPaymentOnBehalf",
        method: "post",
        data: data,
    });
};

// 判断是否登录了
export const checkIsLogin = (data = {}) => {
    return request({
        url: "/qgvip/loginController/checkIsLogin",
        method: "post",
        data: data,

    });
};

/** 优惠认证 */
// 认证角色字典列表（认证字段默认传入"0005"）
export const listWorkbook = (data = {}) => {
    return request({
        url: "/qgvip/authController/listWorkbook",
        method: "post",
        data: data,

    });
};
// 认证列表
export const listAuth = (data = {}) => {
    return request({
        url: "/qgvip/authController/listAuth",
        method: "post",
        data: data,

    });
};
// 新增认证
export const submitAuthCert = (data = {}) => {
    return request({
        url: "/qgvip/authController/submitAuthCert",
        method: "post",
        data: data,

    });
};
// 新增认证
export const reSubmitAuthCert = (data = {}) => {
    return request({
        url: "/qgvip/authController/reSubmitAuthCert",
        method: "post",
        data: data,

    });
};
export const excelOpenParkingRecord = (data = {}) => {
    return request({
        url: "/qgzlpt/openParkingRecordController/excelOpenParkingRecord",
        method: "get",
        params: {
            filterTime: '',
            parkName: '',
            parkCode: '',
            plateNum: '',
            status: '',
            zt: 1,
            isPay: '',
            flag: '',
            timeType: 0,
            monthlyType: '',
            parkingRecordId: '',
            areaCode: 350505,
            beginTime: "2023-12-01 00:00:00",
            endTime: "2023-12-31 23:59:59"
        },
    });
}
